export const AboutRescue = () => {
  return (
    <section
      id="about-rescue"
      data-testid="about-rescue-section"
      className="relative border-t border-white/10 bg-[#050505] py-20 md:py-28"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-px bg-white/10 border border-white/10">
          {/* Left: label + heading */}
          <div className="col-span-12 md:col-span-4 bg-[#0a0a0a] p-8 md:p-10 flex flex-col">
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-[#FF3B30]">
              // The Competition
            </div>
            <h2
              data-testid="about-rescue-title"
              className="font-display font-black uppercase mt-4 leading-[0.9] text-3xl md:text-4xl lg:text-5xl"
            >
              What is
              <br />
              <span className="text-outline">RoboCup</span>
              <br />
              Rescue<span className="text-[#FF3B30]">?</span>
            </h2>
            <div className="mt-auto pt-8 font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
              Disaster Sim · International Stage
            </div>
          </div>

          {/* Middle: description */}
          <div className="col-span-12 md:col-span-5 bg-[#0a0a0a] p-8 md:p-10">
            <p className="font-body text-base md:text-lg text-white/80 leading-relaxed">
              An international competition where teams build robots
              capable of navigating disaster simulation environments. Robots are scored on
              traversing obstacles, maneuvering through doorways, flipping over terrain
              with articulated flippers, and gathering critical data using thermal
              cameras, standard cameras, and sensor arrays.
            </p>
            <p className="mt-5 font-body text-base text-white/65 leading-relaxed">
              Tasks simulate real-world search-and-rescue scenarios — reading signs,
              detecting heat signatures, moving debris, and operating in confined or
              unstable spaces.
            </p>
          </div>

          {/* Right: standout stat */}
          <div className="col-span-12 md:col-span-3 bg-[#0a0a0a] p-8 md:p-10 flex flex-col justify-between">
            <div>
              <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
                The Distinction
              </div>
              <div className="mt-5 font-display font-black uppercase leading-[0.9] text-3xl md:text-4xl text-white">
                Only<br />
                <span className="text-[#FF3B30]">High School</span><br />
                team
              </div>
              <div className="mt-4 font-body text-sm text-white/60 leading-relaxed">
                BSM Robotics is the only high school program in this division —
                competing head-to-head against college and university teams worldwide.
              </div>
            </div>
            <div className="mt-8 font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40">
              ↳ vs. Universities
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
